//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { v4 as uuid } from 'uuid'
import {
  INPUT_TYPE_TEXT,
  INPUT_TYPE_PASSWORD,
  INPUT_TYPE_EMAIL,
  INPUT_TYPE_TEL,
  INPUT_TYPE_NUMBER,
  INPUT_TYPE_URL,
  INPUT_TYPE_TEXTAREA,
  INPUT_TYPE_DATE,
  INPUT_VARIANT_DEFAULT,
  INPUT_VARIANTS,
  INPUT_VARIANT_DENSE,
  INPUT_VARIANT_DENSE_SM,
} from '../../utils/constants'

const ALLOWED_TYPES = [
  INPUT_TYPE_TEXT,
  INPUT_TYPE_PASSWORD,
  INPUT_TYPE_EMAIL,
  INPUT_TYPE_TEL,
  INPUT_TYPE_NUMBER,
  INPUT_TYPE_URL,
  INPUT_TYPE_TEXTAREA,
  INPUT_TYPE_DATE,
]
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: INPUT_TYPE_TEXT,
      validator: (type) => ALLOWED_TYPES.includes(type),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    nativeValidityReporting: {
      type: Boolean,
      default: false,
    },
    onlyNativeValidityReporting: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
    dataTestId: {
      type: String,
      default: null,
    },
    displayEmpty: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: null,
    },
    pattern: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: INPUT_VARIANT_DEFAULT,
      validator: (x) => Object.keys(INPUT_VARIANTS).includes(x),
    },
    dense: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    min: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      id: `dt-input-${this.type}-${uuid()}`,
      hasFocus: false,
      localNativeValidityReporting: false,
      touched: false,
      previouslySentValue: null,
    }
  },
  computed: {
    isInput() {
      return this.type !== 'textarea'
    },
    isTextarea() {
      return !this.isInput
    },
    labelClass() {
      const cls = [
        'tw-pr-2',
        'tw-rounded',
        'tw-pointer-events-none',
        'tw-absolute',
        'tw-top-1',
        'tw-left-2',
        'tw-text-[11px]',
        'md:tw-top-1.5',
      ]

      if (this.dark) {
        cls.push(
          this.disabled
            ? 'tw-text-gray-200 tw-opacity-[0.43]'
            : 'tw-text-gray-300',
        )
      } else {
        cls.push(this.disabled ? 'tw-text-gray-400' : 'tw-text-gray-500')
      }

      if (!this.isDenseSMVariant) {
        cls.push('md:tw-left-3')
      }

      if (this.error) {
        cls.push('tw-text-red-500')
      }

      if (this.isTextarea) {
        cls.push('tw-bg-white/90')
      }

      return cls
    },
    classForInput() {
      const cls = [
        'tw-w-full',
        'tw-min-w-0',
        'tw-appearance-none',
        'tw-rounded-lg',
        'tw-border-transparent',
        'tw-bg-transparent',
        'tw-leading-snug',
        'tw-ring-1',
        'tw-font-normal',
        'focus:tw-border-transparent',
        'focus:tw-ring-1',
        'disabled:tw-cursor-not-allowed',
      ]

      if (this.dark) {
        cls.push(
          'tw-text-white tw-placeholder-gray-300 tw-ring-gray-600 disabled:tw-opacity-[0.43] disabled:tw-bg-gray-700 disabled:tw-text-gray-200 disabled:tw-placeholder-gray-200 disabled:tw-ring-gray-500 focus:tw-ring-white foucs:tw-ring-offset-white',
        )
      } else {
        cls.push(
          'tw-text-gray-600 tw-placeholder-gray-500 disabled:tw-placeholder-gray-400 disabled:tw-text-gray-400 disabled:tw-bg-gray-50 tw-ring-gray-200 focus:tw-ring-gray-800 focus:tw-ring-offset-gray-800',
        )
      }

      if (this.touched && this.dark) {
        cls.push(
          'invalid:tw-ring-1 invalid:tw-ring-red-500 invalid:tw-placeholder-gray-200 invalid:tw-bg-red-500/[12%] focus:invalid:tw-bg-red-500/[12%] focus:invalid:tw-ring-red-500',
        )
      } else if (this.touched) {
        cls.push(
          'invalid:tw-ring-1 invalid:tw-ring-red-500 invalid:tw-placeholder-red-500 invalid:tw-bg-red-50 focus:invalid:tw-bg-white focus:invalid:tw-ring-red-500',
        )
      }

      if (!(this.noLabel && this.placeholder)) {
        cls.push('focus:tw-placeholder-opacity-0')
      }

      // tailwind forms plugin class
      if (this.isTextarea) {
        cls.push('tw-form-textarea')
      } else {
        cls.push('tw-form-input')
      }

      cls.push(this.sizeVariant)

      if (this.value && this.dark) {
        cls.push('invalid:!tw-bg-transparent')
      } else if (this.value) {
        cls.push('invalid:!tw-bg-white')
      } else if (this.error) {
        cls.push('invalid:tw-bg-red-50')
      }

      if (this.inputClass) {
        cls.push(this.inputClass)
      }

      if (this.$slots.append) {
        cls.push('tw-pr-14')
      } else {
        cls.push('tw-pr-2', !this.isDenseSMVariant && 'md:tw-pr-3')
      }

      if (this.$slots.prepend) {
        cls.push('tw-pl-8', !this.isDenseSMVariant && 'md:tw-pl-10')
      } else {
        cls.push('tw-pl-2', !this.isDenseSMVariant && 'md:tw-pl-3')
      }

      return cls
    },
    isDenseSMVariant() {
      return INPUT_VARIANT_DENSE_SM === this.variant || this.dense
    },
    sizeVariant() {
      const cls = []
      const variant = this.dense ? INPUT_VARIANT_DENSE_SM : this.variant
      switch (variant) {
        case INPUT_VARIANT_DENSE:
          if (this.labelVisible) {
            cls.push('tw-pt-4 tw-pb-0.5')
          } else {
            cls.push('tw-py-[9px]')
          }
          break
        case INPUT_VARIANT_DENSE_SM:
          if (this.labelVisible) {
            cls.push('tw-pt-4.5 tw-pb-0.5')
          } else {
            cls.push('tw-py-2')
          }
          break
        default:
          if (this.labelVisible) {
            cls.push('tw-pt-5 tw-pb-1 md:tw-pt-6 md:tw-pb-2')
          }
          cls.push('tw-py-3 md:tw-py-4')
          break
      }
      return cls
    },
    labelVisible() {
      return (
        this.label &&
        (this.value || this.hasFocus || this.displayEmpty) &&
        !this.noLabel
      )
    },
    addonClass() {
      return [
        'tw-absolute',
        'tw-flex',
        'tw-items-center',
        'tw-text-sm md:tw-text-base',
        'tw-text-gray-400',
      ]
    },
    prependClass() {
      const cls = [...this.addonClass]

      switch (this.variant) {
        case INPUT_VARIANT_DENSE:
          cls.push(
            this.isInput
              ? this.labelVisible
                ? 'tw-top-5'
                : 'tw-top-2.5 md:tw-top-3'
              : this.labelVisible
              ? 'tw-top-5.5'
              : 'tw-top-3.5',
          )
          break
        case INPUT_VARIANT_DENSE_SM:
          cls.push(
            this.isInput
              ? this.labelVisible
                ? 'tw-top-5.5'
                : 'tw-top-2 md:tw-top-2.5'
              : this.labelVisible
              ? 'tw-top-6'
              : 'tw-top-3.5',
          )
          break
        default:
          cls.push(
            this.isInput
              ? this.labelVisible
                ? 'tw-top-6 md:tw-top-7'
                : 'tw-top-0.5 md:tw-top-0 tw-bottom-0.5 md:tw-bottom-0'
              : this.labelVisible
              ? 'tw-top-6 md:tw-top-7'
              : 'tw-top-4 md:tw-top-5',
          )
          break
      }

      if (this.hasFocus) {
        cls.push('tw-z-20')
      }

      return cls
    },
    appendClass() {
      return this.addonClass.concat(['tw-bottom-0 tw-top-0'])
    },
    computedLabel() {
      if (this.required && this.label && !this.label.includes('*')) {
        return this.label + '*'
      }
      return this.label
    },
    listeners() {
      return Object.assign({}, this.$listeners, {
        input: this.onInput,
        focus: this.onFocus,
        blur: this.onBlur,
      })
    },
  },
  watch: {
    error() {
      this.setFieldValidity()
    },
    nativeValidityReporting: {
      immediate: true,
      handler(inUse) {
        this.localNativeValidityReporting = inUse
      },
    },
    onlyNativeValidityReporting: {
      immediate: true,
      handler(inUse) {
        this.localNativeValidityReporting = inUse
      },
    },
    value(newVal) {
      // this check prevents displaying invalid state for inputs when values are being cleared via code. For example after form submission in many cases inputs will be cleared and these inputs shouldn't rely on old touched state.
      if (this.touched && newVal !== this.previouslySentValue) {
        this.touched = false
      }
    },
  },
  mounted() {
    this.setFieldValidity()
    if (this.dense) {
      console.warn(
        '[DTInput] Dense property has been deprecated, please use variant="dense-sm" instead.',
      )
    }
  },
  methods: {
    focusInput() {
      this.$refs.field.focus()
    },
    onInput(e) {
      this.$emit('input', e.target.value)
      this.previouslySentValue = e.target.value
    },
    onFocus(e) {
      this.hasFocus = true
      this.$emit('focus', e)

      if (this.error && this.localNativeValidityReporting) {
        this.$refs.field.reportValidity()
      }
    },
    onBlur(e) {
      this.hasFocus = false
      this.touched = true
      this.$emit('blur', e)
    },
    setFieldValidity() {
      if (this.error) {
        this.$refs.field.setCustomValidity(this.error)
      } else {
        this.$refs.field.setCustomValidity('')
      }
      if (this.localNativeValidityReporting) {
        this.$refs.field.reportValidity()
      }
    },
  },
}
